import React, { useEffect, useState } from 'react'
import styles from './about.module.css'
import saro from "../../imgs/saro.jpg"
import coFounder from "../../imgs/vahan.png"
import { useTranslation } from "react-i18next"
import { useGetClientCountsQuery } from "../../features/clientCount/clientCountApiSlice"
import useScrollTop from "../../hooks/useScrollTop"
import { Link } from "react-router-dom"
import { FaCalendarAlt, FaUsers, FaTh } from "react-icons/fa"
import { backURL } from "../../consts"

const About = () => {
    const { t } = useTranslation()
    const workingYears = new Date().getFullYear() - 2018
    const { data: clientsCount } = useGetClientCountsQuery()

    // Фото основателей из админки; если не загружены — статичные saro/vahan
    const [founderImgs, setFounderImgs] = useState<Record<string, string>>({})
    useEffect(() => {
        const apiUrl = process.env.REACT_APP_API_URL ?? 'https://www.back.svecha.am/api'
        fetch(`${apiUrl}/founder`)
            .then(r => (r.ok ? r.json() : []))
            .then((rows: Array<{ role: string; image: string }>) => {
                const map: Record<string, string> = {}
                for (const f of rows) if (f.image) map[f.role] = `${backURL}/${f.image}`
                setFounderImgs(map)
            })
            .catch(() => { /* fallback на статичные фото */ })
    }, [])

    const founderSrc = founderImgs['founder'] ?? saro
    const coFounderSrc = founderImgs['cofounder'] ?? coFounder

    useScrollTop()

    return (
        <div>
            {/* ── Hero ── */}
            <section className={styles.hero}>
                <div className={styles.hero_inner}>
                    <h1>{t("menu.about_us")}</h1>
                    <p>{t("about.our_goal_2")}</p>
                    <div className={styles.hero_rule} />
                </div>
            </section>

            {/* ── Intro ── */}
            <section className={styles.intro}>
                <div className="app_container">
                    <div className={styles.intro_grid}>
                        <div className={styles.intro_text}>
                            <span className={styles.badge}>
                                <FaCalendarAlt className={styles.badge_icon} />
                                {t("about.founded")}
                            </span>
                            <h2>Svecha.am</h2>
                            <p>{t("about.text1")}</p>
                        </div>
                        <div className={styles.founders}>
                            <div className={styles.founder}>
                                <div className={styles.founder_frame}>
                                    <img src={founderSrc} alt={t("about.founder_name") || ''} />
                                </div>
                                <div className={styles.founder_name}>{t("about.founder_name")}</div>
                                <div className={styles.founder_role}>{t("about.founder")}</div>
                            </div>
                            <div className={styles.founder}>
                                <div className={styles.founder_frame}>
                                    <img src={coFounderSrc} alt={t("about.co_founder_name") || ''} />
                                </div>
                                <div className={styles.founder_name}>{t("about.co_founder_name")}</div>
                                <div className={styles.founder_role}>{t("about.co_founder")}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── Principles ── */}
            <section className={styles.principles}>
                <div className="app_container">
                    <h2>{t("about.principles_heading")}</h2>
                    <div className={styles.principles_grid}>
                        <div className={styles.pcard}>
                            <span className={styles.pcard_num}>1</span>
                            <p>{t("about.point1")}</p>
                        </div>
                        <div className={styles.pcard}>
                            <span className={styles.pcard_num}>2</span>
                            <p>{t("about.point2")}</p>
                        </div>
                        <div className={styles.pcard}>
                            <span className={styles.pcard_num}>3</span>
                            <p>{t("about.point3")}</p>
                        </div>
                    </div>
                    <div className={styles.closing}>
                        <p>{t("about.text2")}</p>
                        <p className={styles.motto}>{t("about.text3")}</p>
                    </div>
                </div>
            </section>

            {/* ── Stats + CTA (единая тёмная секция) ── */}
            <section className={styles.stats}>
                <div className={styles.stats_grid}>
                    <div className={styles.stat}>
                        <FaCalendarAlt className={styles.stat_icon} />
                        <div className={styles.stat_num}>{workingYears}</div>
                        <div className={styles.stat_label}>{t("about.working_years")}</div>
                    </div>

                    <div className={styles.cta_col}>
                        <p className={styles.cta_text}>{t("about.cta_text")}</p>
                        <Link to="/products/spark_plugs" className={styles.cta_btn}>
                            <FaTh /> {t("about.cta_btn")}
                        </Link>
                    </div>

                    <div className={styles.stat}>
                        <FaUsers className={styles.stat_icon} />
                        <div className={styles.stat_num}>{clientsCount ?? '—'}</div>
                        <div className={styles.stat_label}>{t("about.our_clients")}</div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default About
